export const featureSignUpTrackingIds = {
  tableUpgradeSubscriptionAction: 'feature-sign-up-table-upgrade-subscription-action',
  tableStartTrialAction: 'feature-sign-up-table-start-trial-action',
  tableScheduleCallAction: 'feature-sign-up-table-schedule-call-action',
};
